import React from 'react';
import moment, { Moment as MomentType } from 'moment';

import { mapValues } from 'lodash';
//import { date as fakerDate } from 'faker';
import 'moment/locale/it';
//import Holidays from 'date-holidays';

import * as Moment2 from 'moment';
//import { extendMoment } from 'moment-range';

// const holidays = new Holidays();
// holidays.init('IT');

moment.locale('it');

//export const MomentRanged = extendMoment(Moment2);

export const Moment = moment;
export const defaultDateFormat = 'DD/MM/YYYY';
export const defaultTimeFormat = 'HH:mm';
export const defaultDateTimeFormat = `${defaultDateFormat} ${defaultTimeFormat}`;
export const defaultServerSendDate = 'YYYY-MM-DD HH:mm';
export const XlxsDateFormat = 'MM-DD-YYYY';
export type IMoment = MomentType;
export const isInTurnRange = (current: moment.Moment) =>
  current.isBetween(Moment().subtract(8, 'hours'), Moment().add(8, 'hours'));

export const getMonths = (short: boolean = true) =>
  short ? moment.monthsShort() : moment.months();

// export const dateValidation = (data, hours, author = null, user = null) => {
//   let createdAt = new Date(data * 1000);
//   let createdAtPlus6Hours = createdAt.setHours(createdAt.getHours() + hours);
//   if (
//     new Date(data * 1000) < new Date(Date.now()) &&
//     new Date(createdAtPlus6Hours) > new Date(Date.now()) &&
//     author &&
//     author.id === user.id
//   ) {
//     return true;
//   }
//   return false;
// };
export const disabledDateFuture = (current) => {
  return current && current > moment().endOf('day');
};
export const disabledDateFutureAndPast = (current) => {
  return current && (moment().diff(current, 'days') != 0 || current > moment().endOf('day'));
};
export const disabledDateInRange = (current, start, end) => {
  return !(start.isSameOrBefore(current) && end.isAfter(current));
};
export const disabledDatePast = (current) => {
  return current && current < moment().startOf('day');
};
export const disabledTimeFuture = (current?) => {
  if (current) {
    if (moment().diff(current, 'days') === 0) {
      if (new Date().getHours() > current.hour()) {
        return {
          disabledHours: () => range(new Date().getHours(), 24),
        };
      }
      return {
        disabledHours: () => range(new Date().getHours(), 24),
        disabledMinutes: () => range(new Date().getMinutes(), 60),
      };
    }
  } else {
    return {
      disabledHours: () => range(new Date().getHours(), 24),
      disabledMinutes: () => range(new Date().getMinutes(), 60),
    };
  }
};
export const disabledTimePast = (current, minMinutes: number = 0) => {
  const selected = Moment(current);
  const now = Moment();
  if (current) {

    if (selected.date() === now.date()) {

      if (selected.hours() === now.hours()) {

        return {
          disabledHours: () => range(0, now.hours()),
          disabledMinutes: () => range(0, now.minutes() + minMinutes),
        };
      } else {

        return {
          disabledHours: () => range(0, now.hours()),
        };
      }
    }
  } else {
    return {};
  }
};
function range(start, end) {
  const result: any = [];
  for (let i = start + 1; i < end; i++) {
    result.push(i);
  }
  return result;
}
export const isBefore = (creationDate, diff = 6) => {
  const dat = moment(creationDate).add(diff, 'hours');
  const now = moment();
  return now.isBefore(dat);
};
export const DateNow = (dateFormat = defaultDateFormat) => {
  return moment().format(dateFormat).toString();
};

export const FormatDate = (dateString, dateFormat = defaultDateFormat) => {
  const date = moment(dateString);
  return date.isValid() ? date.format(dateFormat) : '';
};

export const FormatUnixDate = (dateString, dateFormat = defaultDateFormat) => {
  return FormatDate(moment(dateString, 'X'), dateFormat);
};

export const FormatDateTime = (dateString, dateFormat = defaultDateTimeFormat) => {
  return moment(dateString).format(dateFormat);
};

export const FormatSendDate = (dateString, defaultFormat = defaultServerSendDate) => {
  // 2017-02-04
  return moment(dateString).format(defaultFormat);
};

export const FormatSendTime = (dateString, defaultFormat = defaultTimeFormat) => {
  // 2017-02-04
  return moment(dateString).format(defaultFormat);
};

export const FormatCustomDate = (dateString, dataInputFormat, dateFormat = defaultDateFormat) => {
  return moment(dateString, dataInputFormat).format(dateFormat);
};

export const isDate = (date) => {
  const regex =
    /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/gm;

  return regex.test(date);
};

export const getAge = (birthday, inputDateFormat = 'YYYY-MM-DD') => {
  return moment().diff(moment(birthday, inputDateFormat), 'years');
};

export const formatDatesInPayload = (payload) => {
  return mapValues(payload, (data) => {
    if (moment.isMoment(data) || moment.isDate(data)) {
      data = moment(data).format('YYYY-MM-DD');
    }
    return data;
  });
};

export const NOW = () => Moment();


export const getIsoWeekDay = () => {
  return moment().isoWeekday();
};

export const getWeekDays = () => {
  var startOfWeek = Moment().startOf('week');
  var endOfWeek = Moment().endOf('week');

  var days: IMoment[] = [];
  var day = startOfWeek;

  while (day <= endOfWeek) {
    days.push(day);
    day = day.clone().add(1, 'd');
  }

  return days;
};

// export const isHolyday = (date: IMoment) => {
//   if (!date) return false;
//   return holidays.isHoliday(date.toDate());
// };

export const isServerDate = (date) => {
  const regex = /(\d{2})-(\d{2})-(\d{4}) ?((\d{2}):(\d{2}):(\d{2}))?/gm;

  return regex.test(date);
};

export const convertToJSDate = (date: string) => {
  return Moment(date, 'DD-MM-YYYY HH:mm').toDate();
};

export const zeroTime = (date: IMoment | any): any => {
  if (Moment.isMoment(date)) {
    return date.clone().minutes(0).seconds(0).milliseconds(0);
  } else {
    return Moment(date).clone().minutes(0).seconds(0).milliseconds(0).valueOf();
  }
};
